import React, { useState } from "react";
import {
    Avatar,
    Badge,
    Box,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from '@mui/material'

export default function ModalListItem(props) {

    const { item } = props
    const [itemHover, setItemHover] = useState(false)


    return (
        <ListItem
            sx={{
                backgroundColor: itemHover ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.4)',
                cursor: !(item?.isActive ?? false) ? 'pointer' : 'default'
            }}
            onMouseEnter={() =>  setItemHover(true)}
            onMouseLeave={() => setItemHover(false)}
            onClick={(event) => item?.onClick ? !(item?.isActive ?? false) && item.onClick(event) : console.log('Not Implemented')}
        >
            <ListItemAvatar>
                <Badge
                    overlap='circular'
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right'}}
                    badgeContent={
                        (item?.isActive ?? false)
                        ?
                        <Box
                            position={'absolute'}
                            right={0}
                            m={'10px'}
                            borderRadius={'5px'}
                            width={'10px'}
                            height={'10px'}
                            sx={{
                                backgroundColor: 'rgb(92, 230, 92)',
                                boxShadow: '0 0px 5px rgba(0, 0, 0, 1)'
                            }}
                        />
                        :
                        <></>
                    }
                >
                    <Avatar
                        src={item?.icon}
                        children={'K'} // If image broken, then fallback to empty string to avoid showing generic user icon
                        sx={{
                            backgroundColor: 'rgb(0, 0, 0)',
                            color: 'rgb(187, 234, 178)',
                            fontWeight: 'bold'
                        }}
                    />
                </Badge>
            </ListItemAvatar>
            <ListItemText
                sx={{
                    '& .MuiListItemText-primary': {
                        color: 'rgb(187, 234, 178)'
                    },
                    '& .MuiListItemText-secondary': {
                        color: 'rgba(255, 255, 255, 0.6)',
                        fontSize: '12px'
                    }
                }}
                primary={item?.primaryText ?? ''}
                secondary={item?.secondaryText ?? ''}
            />
        </ListItem>
    )
}